import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { useNotify } from 'react-admin';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import ModalView from './ModalView';
import { useCustomerDetailsStyles } from './CustomerDetails';
import DialogTitle from '../../components/DialogTitle';
import { apiPut } from '../../brainApi';

const RemoveUser = ({ open, setOpen, userId, users, setUsers }) => {
  const classes = useCustomerDetailsStyles();
  const notify = useNotify();
  const [isRemoving, setIsRemoving] = useState(false);

  const handleRemove = () => {
    const payload = { is_deleted: true };
    setIsRemoving(true);
    apiPut(`/user/${userId}`, payload).then((res) => {
      let message;
      let isWarning;
      if (res.Status === 'Failure') {
        message = res.Message;
        isWarning = true;
      } else {
        const updatedUsers = users.filter((u) => u.id !== userId);
        setUsers(updatedUsers);
        message = 'User removed successfully';
        isWarning = false;
      }
      setOpen(false);
      notify(message, isWarning && 'warning');
      setIsRemoving(false);
    });
  };

  return (
    <ModalView openEdit={open} setOpenEdit={setOpen}>
      <DialogTitle>Are you sure you want to remove this user?</DialogTitle>
      <Box display="flex" justifyContent="center">
        <Button className={classes.nowrap} onClick={() => setOpen(false)}>
          <Typography variant="button">Cancel</Typography>
        </Button>
        <Button className={classes.nowrap} onClick={handleRemove}>
          {isRemoving && (
            <CircularProgress size={20} style={{ marginRight: 10 }} />
          )}
          <Typography variant="button" color="error">
            Remove
          </Typography>
        </Button>
      </Box>
    </ModalView>
  );
};

export default RemoveUser;
